import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../Loader/Loader.js";
import { loaderOverlay } from "../../Style/loaderOverly.js";
import { createPageData, basicFormData } from "./DispatchedFile.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";
import Select from "react-select";
import CustomError from "../../custom/components/Errors/CustomError.js";

const DispatchedFrom = ({ jobCardNo, jobCardData }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, headerName, validationType, createEndpoint, navigatePage } =
    createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [loadingSubmit, setLoadingSubmit] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});

  const [techniciansError, setTechniciansError] = useState("");
  const [popup, setPopup] = useState(false);
  const [action, setAction] = useState("");
  const [scrapReasonsError, setScrapReasonsError] = useState("");
  const getOnlyDate = (date) => {
    const receivedDate = new Date(date).toLocaleDateString();
    const [day, month, year] = receivedDate?.split("/");
    const formatted = `${year}-${month}-${day}`;
    return formatted;
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "is_repairable" && checked === false) {
      setTechniciansError("");
    }
    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
            ? null
            : value,
      },
    }));
  };

  // Submit

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingSubmit(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const userId = userDetails?.id;

      const jobCardStatusUpdatePayload = {
        modelName: "dispatcheds",
        schema: payload?.schema,
        inputData: {
          intake_id: jobCardData.intake_id,
          remark: formData.inputData.remark,
          is_active: true,
          dispatched_by: userId,
        },
      };
      const responseData = await saveRecords(
        jobCardStatusUpdatePayload,
        createEndpoint
      );

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate("/dispatched-list");
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingSubmit(false);
      // setPopup(false)
    }
  };

  return (
    <div>
      <div className="card p-3">
        <h5 className="mb-3 border border-0">Job Card Details</h5>

        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <Row>
                {/* First Section (Left Side) */}
                <Col md="6" className="border-end border-secondary p-3">
                  <p>
                    <strong>Job Card No: </strong>
                    {jobCardData?.job_card_no || "-"}
                  </p>
                  <p>
                    <strong>Technician Check At: </strong>
                    {jobCardData?.technician_check_at
                      ? getOnlyDate(jobCardData?.technician_check_at)
                      : "-"}
                  </p>

                  <p>
                    <strong>Job Card Status: </strong>
                    {jobCardData?.status || "-"}
                  </p>
                  {/* <p>
                    <strong>Technician Check Remark: </strong>
                    {jobCardData?.technician_check_remark || "-"}
                  </p> */}
                </Col>

                {/* Second Section (Right Side) */}
                <Col md="6" className="p-3">
                  <p>
                    <strong>Item Name: </strong>
                    {jobCardData?.intake?.material?.name || "-"}
                  </p>
                  <p>
                    <strong>Intake No: </strong>
                    {jobCardData?.intake?.intake_no || "-"}
                  </p>
                  <p>
                    <strong>Serial No: </strong>
                    {jobCardData?.intake?.material_serial_no || "-"}
                  </p>

                  {/* <p>
                    <strong>Item Intake Status: </strong>
                    {jobCardData?.intake?.status || "-"}
                  </p> */}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div className="card p-3">
        <Row>
          <Col md="6">
            <TextInput
              label="Dispatch Remark"
              name="remark"
              value={formData.inputData?.remark}
              onChange={onInputChange}
              placeholder="Enter Dispatch Remark"
              // asterisk={true}
              inputClassName="form-control"
              labelClassName="form-label"
              customError={formErrors?.remark}
            />
          </Col>
        </Row>

        <div className="mt-3 d-flex gap-3 flex-wrap">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              const validateRemark = validate(
                validationType,
                formData.inputData
              );
              setFormErrors(validateRemark);
              if (JSON.stringify(validateRemark) !== "{}") return;
              setPopup(true);
            }}
          >
            Dispatch
          </button>
          <button
            type="button"
            onClick={() => {
              navigate(navigatePage?.back);
            }}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>
      </div>

      <BasicPopupModel
        isVisible={popup}
        onClose={() => setPopup(false)}
        title={"Are you sure you want to dispatch this job card?"}
      >
        <div className="mt-3">
          <div className="text-center">
            <span>Job Card No: </span> <strong>{jobCardNo}</strong>
          </div>
          <div className="mt-3 d-flex gap-3 flex-wrap justify-content-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => {
                handleSubmit(e);
                setPopup(false);
              }}
            >
              Dispatch
            </button>
            <button
              type="button"
              onClick={() => {
                setPopup(false);
              }}
              className="btn btn-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      </BasicPopupModel>
      {(loadingData || loadingSubmit) && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </div>
  );
};

export default DispatchedFrom;
